import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getGiaoHangReportState = state => state.giaoHangReport;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function handleFileRequest(request) {
  return request
    .then(function (response) {
      return response.data;
    })
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}

function giaoHangReportListNvRequestApi(formData) {
  const request = axiosApi().post(
    Constants.GIAOHANG_REPORT_LIST_NV_API,
    formData
  )

  return handleRequest(request);
}

function exportXlsRequestApi(formData) {
  let url = `${Constants.GIAOHANG_REPORT_EXPORT_API}?store_id=${formData.store_id}`
  url += `&keyword=${formData.keyword}&den_ngay=${formData.den_ngay}&tu_ngay=${formData.tu_ngay}&status=${formData.status}&nvGiaoHang=${formData.nvGiaoHang}`;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}

function* giaoHangReportListNvFlow(action) {
  try {
    // grab the client from our action
    const { formData, callback } = action
    const results = yield call(giaoHangReportListNvRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(brActions.giaoHangReportListNvSuccess(results.data))

    if (typeof callback == 'function') {
      callback(results.data.records || []);
    }
  } catch (error) {
    yield put(brActions.giaoHangReportListNvError(error))
  }
}

function* giaoHangReportListRequestFlow() {
  const giaoHang = yield select(getGiaoHangReportState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, giaoHang.formData)

    // dispatch the action with our widgets!
    yield put(brActions.giaoHangReportListSuccess(results.data))

  } catch (error) {
    yield put(brActions.giaoHangReportListError(error))
  }
}

function* giaoHangReportExportXlsRequestFlow({ payload, onSuccess }) {
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, payload)
    if (!results || (results.code && results.code != 200)) {
      return yield put(brActions.giaoHangReportExportXlsError("Lỗi trong quá trình lấy dữ liệu"))
    }
    if (results.code && results.code != 200) {
      return yield put(brActions.giaoHangReportExportXlsError(results.message))
    }
    // dispatch the action with our widgets!
    yield put(brActions.giaoHangReportExportXlsSuccess())
    // callback on success
    if (typeof onSuccess === 'function') {
      yield call(onSuccess, results)
    }
  } catch (error) {
    yield put(brActions.giaoHangReportExportXlsError(error))
  }
}

function* giaoHangReportWatcher() {
  yield [
    takeLatest(Constants.GIAOHANG_REPORT_LIST_REQUESTING, giaoHangReportListRequestFlow),
    takeLatest(Constants.GIAOHANG_REPORT_LIST_NV_REQUESTING, giaoHangReportListNvFlow),
    takeLatest(Constants.GIAOHANG_REPORT_EXPORT_XLS_REQUESTING, giaoHangReportExportXlsRequestFlow),
  ]
}

export default giaoHangReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/GiaoHangReport/sagas.js